// extracted by mini-css-extract-plugin
module.exports = {"chat_tools":"chat_chat_tools__1vmwo","chat_wrapper":"chat_chat_wrapper__3ktOy","chat_wrapper_footer":"chat_chat_wrapper_footer__yzx4N"};